/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestTransitDetectionCheckTransport } from '../model/models';
import { ApiResponseTransitDetectionCheckTransport } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface TransitDetectionTesterServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param apiRequestTransitDetectionCheckTransport 
     */
    transitDetectionTesterControllerByTransportId0(apiRequestTransitDetectionCheckTransport: ApiRequestTransitDetectionCheckTransport, extraHttpRequestParams?: any): Observable<ApiResponseTransitDetectionCheckTransport>;

    /**
     * 
     * 
     * @param apiRequestTransitDetectionCheckTransport 
     */
    transitDetectionTesterControllerByTransportId1(apiRequestTransitDetectionCheckTransport: ApiRequestTransitDetectionCheckTransport, extraHttpRequestParams?: any): Observable<ApiResponseTransitDetectionCheckTransport>;

}
